/* eslint-disable */
import $ from 'jquery';
import _ from 'underscore';
import backbone from 'backbone';
import ko from 'knockout';
import tmpl from '@bingads-webui-component-legacy/upgraded-url/template/finalUrl.pug';
import ViewModel from '@bingads-webui-component-legacy/upgraded-url/viewmodel/finalURL';
import UrlEditor from '@bingads-webui-component-legacy/url-input/view/url-input';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!component/upgraded-url');
var view = backbone.View.extend({
  initialize: function (options) {
    this.options = options || ({});
    _.defaults(this.options, {
      template: tmpl,
      isFinal: true
    });
    this.ko_model = new ViewModel(this.options);
  },
  events: {
    'click .radio-final-url': 'finalUrlSelected',
    'click .radio-destination-url': 'destinationUrlSelected'
  },
  render: function () {
    this.$el.html($(tmpl({
      i18n: i18n
    })));
    ko.applyBindings(this.ko_model, this.el);
    return this;
  },
  getValues: function () {
    return {
      isFinal: this.ko_model.isFinalUrl()
    };
  },
  finalUrlSelected: function () {
    if (this.ko_model.isFinalUrl()) {
      this.trigger('finalUrlSelected');
    }
  },
  destinationUrlSelected: function () {
    if (!this.ko_model.isFinalUrl()) {
      this.trigger('destinationUrlSelected');
    }
  }
});
export default view;

